<template>
  <!-- 修改预算弹窗 -->
  <van-dialog
    class="budget-dialog"
    v-model="showBudgetDialog"
    :show-confirm-button="true"
    :show-cancel-button="true"
    @confirm="handleConfirm"
    @cancel="onCancel"
    @closed="onCancel"
  >
    <div class="dialog-header">
      <div class="dialog-title">{{ dialogTitle }}</div>
    </div>
    <van-form class="budget-form" ref="budgetForm">
      <!-- 修改预算 -->
      <van-field
        v-if="mode == 'budget'"
        label="追加金额"
        v-model="formData.amount"
        type="digit"
        placeholder="追加金额不能低于100元"
        :rules="[
          { required: true, message: '请输入追加金额' },
          { validator: validateAmount, message: '追加金额不能低于100元' },
        ]"
      >
        <template #button>
          <span style="color: #a5a5a5">元</span>
        </template>
      </van-field>
      <!-- 修改出价 -->
      <template v-if="mode == 'quote'">
        <van-field
          v-model="formData.unitPrice"
          name="unitPrice"
          label="优化目标出价"
          type="number"
          :placeholder="
            depth === '7' ? '请输入1-1000元' : '出价范围：0.5-10000'
          "
          :rules="[
            { required: true, message: '请填写优化目标出价' },
            { validator: validatePrice1, message: ValidateRules },
          ]"
        >
        </van-field>
        <van-field
          v-if="depth === '7'"
          v-model="formData.deepUnitPrice"
          name="deepUnitPrice"
          label="深度优化目标出价"
          type="number"
          placeholder="请输入1-10000元"
          :rules="[
            { required: true, message: '请填写深度优化目标出价' },
            { validator: validatePrice2, message: '请输入1-10000元之间的金额' },
            {
              validator: validateDeepPrice,
              message: '深度优化目标出价必须大于优化目标出价',
            },
          ]"
        >
        </van-field>
      </template>

      <!-- 修改投放时间 -->
      <template v-if="mode == 'time'">
        <van-field
          label="结束时间"
          class="release"
          :rules="[{ required: true, message: '请选择' }]"
        >
          <template #input>
            <van-radio-group
              v-model="formData.durationType"
              direction="horizontal"
            >
              <van-radio
                v-for="item in durationOptions"
                :name="item.value"
                :key="item.value"
                :class="{ active: formData.durationType === item.value }"
                >{{ item.label }}</van-radio
              >
            </van-radio-group>
          </template>
        </van-field>

        <div class="rea" v-if="formData.durationType === 'aa'">
          <van-field
            v-model="formData.customDays"
            type="digit"
            :rules="[{ required: true, message: '请输入' }]"
          />
          天
          <van-field
            v-model="formData.customHours"
            type="digit"
            :rules="[{ required: true, message: '请输入' }]"
          />
          小时
        </div>
      </template>

      <!-- 批量复制 -->
      <div v-if="mode == 'copy'" id="xerox">
        <div class="choosModel">
          <span>计划投放</span>
          <div class="models">
            <select id="options" v-model="formData.uploadCount">
              <option
                v-for="item in numberOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.name }}
              </option>
            </select>
            <div
              v-for="item in advertStatus"
              :key="item.value"
              @click="handleStatus(item)"
              :class="{ activeDiv: status == item.value }"
              class="crowd"
            >
              {{ item.name }}
            </div>
          </div>
          <template v-if="status == '2'">
            <van-field name="radio" label="上线时间">
              <template #input>
                <van-radio-group
                  v-model="formData.uploadType"
                  direction="horizontal"
                >
                  <van-radio name="0">立即发布</van-radio>
                  <van-radio name="1">指定时间上线</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field name="radio" label="下线时间">
              <template #input>
                <van-radio-group
                  v-model="formData.endType"
                  direction="horizontal"
                >
                  <van-radio name="0">预定时间到期自动下线</van-radio>
                  <van-radio name="1">指定时间上线</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </template>
        </div>

        <div class="choosModel">
          <span>智能预警</span>
          <van-field name="switch" label="状态">
            <template #input>
              <van-switch v-model="switchChecked" size="20" />
            </template>
          </van-field>
          <template v-if="switchChecked">
            <div class="invest">
              <span class="rept">触发条件</span>
              <span class="stance">
                消耗金额/预算金额≥
                <van-field
                  class="enter-input"
                  type="digit"
                  v-model="formData.forewarning"
                  :rules="[
                    { required: true, message: '请输入' },
                    {
                      validator: validateWarn,
                    },
                  ]"
                >
                  <template #button>
                    <span style="color: #a5a5a5">%</span>
                  </template>
                </van-field>
              </span>
            </div>

            <div class="invest">
              <span class="rept">发送频率</span>
              <span class="stance">
                <select class="rate" v-model="formData.warningFrequency">
                  <option
                    v-for="item in FrequencyOptions"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </span>
            </div>
          </template>
        </div>

        <div class="choosModel">
          <span>支付信息</span>
          <div class="invest">
            <span class="rept"
              >助推订单*{{
                Number(selectedItemsData.length * formData.uploadCount)
              }}</span
            >
            <span class="stance">
              金额：
              <a href="#" style="color: #ff0000"> ¥{{ TotalAmount }}</a>
            </span>
          </div>
        </div>
      </div>
    </van-form>
  </van-dialog>
</template>

<script>
import {
  modifyBudget,
  ModifyBid,
  ReleaseTime,
  BatchCopy,
} from "@/api/modules/boost";
export default {
  data() {
    return {
      showBudgetDialog: false,
      mode: "",
      selectedItems: [], // 存储选中的订单ID
      selectedItemsData: [], // 存储选中的完整订单数据
      depth: "",
      ValidateRules: "",

      durationOptions: [
        { label: "24小时", value: "24" },
        { label: "2天", value: "48" },
        { label: "7天", value: "168" },
        { label: "自定义", value: "aa" },
      ],
      status: "1",
      advertStatus: [
        { value: "1", name: "立即发布" },
        // { value: "2", name: "上下线自动控制" },
      ],
      numberOptions: Array.from({ length: 8 }, (_, i) => ({
        name: i + 1,
        value: i + 1,
      })),
      FrequencyOptions: [
        { label: "2分钟", value: "2" },
        { label: "5分钟", value: "5" },
        { label: "30分钟", value: "30" },
        { label: "1小时", value: "60" },
        { label: "3小时", value: "180" },
        { label: "6小时", value: "360" },
      ],
      switchChecked: true,

      formData: {
        amount: "",
        unitPrice: "",
        deepUnitPrice: "",
        durationType: "",
        customDays: "0",
        customHours: "0",

        uploadCount: 1,
        uploadType: undefined,
        uploadDate: null,
        endType: undefined,
        finishDate: null,
        forewarning: 70,
        warningFrequency: "2", // 频次
      },
    };
  },
  computed: {
    dialogTitle() {
      const titles = {
        budget: "修改预算",
        quote: "修改出价",
        time: "修改投放时间",
        copy: "批量复制",
      };
      return titles[this.mode] || "操作";
    },
    TotalAmount() {
      const aa = this.selectedItemsData.reduce((prev, item) => {
        prev += Number(item.amount * this.formData.uploadCount);
        return prev;
      }, 0);
      return aa;
    },
  },
  watch: {
    "formData.unitPrice"() {
      if (this.formData.deepUnitPrice) {
        this.validateDeepUnitPriceField(); // 调用封装方法
      }
    },
    "formData.deepUnitPrice"(newVal) {
      if (newVal && this.formData.unitPrice) {
        this.validateDeepUnitPriceField(); // 调用封装方法
      }
    },
    depth(newVal) {
      if (newVal == "7") {
        this.ValidateRules = "请输入1-1000元之间的金额";
      } else {
        this.ValidateRules = "请输入0.5-10000元之间的金额";
      }
    },
  },
  methods: {
    // 封装验证逻辑
    async validateDeepUnitPriceField() {
      try {
        await this.$refs.budgetForm.validate("deepUnitPrice");
      } catch (error) {
        // 静默处理错误，避免控制台报错
      }
    },
    // 打开弹窗方法
    openBudgetDialog(selectedIds, selectedData, sift) {
      this.selectedItems = selectedIds;
      this.selectedItemsData = selectedData;
      this.mode = sift;
      this.showBudgetDialog = true;
      this.depth = this.selectedItemsData[0].deepUnitChargeType;
      this.resetForm();
    },
    // 重置表单
    resetForm() {
      this.formData = {
        amount: "",
        unitPrice: "",
        deepUnitPrice: "",
        durationType: "",
        customDays: "0",
        customHours: "0",

        uploadCount: 1,
        uploadType: undefined,
        uploadDate: null,
        endType: undefined,
        finishDate: null,
        forewarning: 70,
        warningFrequency: "2",
      };

      this.switchChecked = true;
      this.status = "1";
    },
    // 投放状态选择
    handleStatus(data) {
      this.status = data.value;
      this.formData.uploadType = this.status == "2" ? "0" : undefined;
      this.formData.endType = this.status == "2" ? "0" : undefined;
    },

    // 提交
    async handleConfirm() {
      try {
        await this.$refs.budgetForm.validate();

        if (this.mode == "copy") {
          let params = {};
          params.supplementOrderIds = this.selectedItemsData.map(
            (item) => item.id
          );
          params.uploadType = this.formData.uploadType;
          params.uploadDate =
            this.formData.uploadType == "1" ? this.formData.uploadDate : null;
          params.endType = this.formData.endType;
          params.finishDate =
            this.formData.endType == "1" ? this.formData.finishDate : null;
          if (this.switchChecked == true) {
            params.forewarning = this.formData.forewarning;
            params.warningFrequency = this.formData.warningFrequency;
          }
          params.uploadCount = this.formData.uploadCount;
          params.warningStatus = this.switchChecked == true ? "1" : "";

          if (this.status == "1") {
            params.uploadType = "0";
          }
          console.log(params, "复制");

          const res = await BatchCopy(params);
          this.handleApiResponse(res);
        } else {
          const payload = this.preparePayload();
          // 修改预算
          if (this.mode == "budget") {
            const res = await modifyBudget(payload);
            this.handleApiResponse(res);
          }

          // 修改出价
          if (this.mode == "quote") {
            const res = await ModifyBid(payload);
            this.handleApiResponse(res);
          }

          // 修改投放时间
          if (this.mode == "time") {
            const res = await ReleaseTime(payload);
            this.handleApiResponse(res);
          }
          console.log(payload, "提交参数");
        }
      } catch (error) {
        if (error !== "Validation failed") {
          this.$toast(error.message);
        }
        // 阻止弹窗关闭
        // this.showBudgetDialog = true;
      }
    },

    handleApiResponse(res) {
      if (res.success || res.result) {
        this.showBudgetDialog = false;
        this.$emit("refresh");
      }
      this.$toast(res.message);
      return res.success;
    },

    preparePayload() {
      return this.selectedItemsData.map((item) => {
        const baseData = {
          advertiserId: item.advertiserId,
          supplementOrderId: item.supplementOrderId,
        };

        switch (this.mode) {
          case "budget":
            return { ...baseData, increasedAmount: this.formData.amount };

          case "quote":
            return {
              ...baseData,
              unitPrice: this.formData.unitPrice,
              deepUnitPrice: this.formData.deepUnitPrice,
            };

          case "time":
            return {
              ...baseData,
              uploadDate: item.uploadDate,
              finishDate: item.finishDate,
              prolongingDate:
                this.formData.durationType === "aa"
                  ? Number(this.formData.customDays) * 24 +
                    Number(this.formData.customHours)
                  : this.formData.durationType,
            };
          default:
            return baseData;
        }
      });
    },

    // 重置
    onCancel() {
      this.showBudgetDialog = false;
      this.resetForm();
    },

    // 金额验证
    validateAmount(val) {
      return Number(val) >= 100;
    },
    validateWarn(val) {
      return val >= 1 && val <= 100;
    },
    // 验证价格1范围
    validatePrice1(val) {
      let aa;
      if (this.depth == "7") {
        aa = val >= 1 && val <= 1000;
      } else {
        aa = val >= 0.5 && val <= 10000;
      }
      return aa;
    },
    // 验证价格2范围
    validatePrice2(val) {
      return val >= 1 && val <= 10000;
    },
    // 验证深度优化目标出价必须大于优化目标出价
    validateDeepPrice(val) {
      const unitPrice = Number(this.formData.unitPrice);
      const deepUnitPrice = Number(val);
      if (isNaN(unitPrice) || isNaN(deepUnitPrice)) return false; // 处理空值或非数字输入
      return deepUnitPrice > unitPrice;
    },
  },
};
</script>

<style scoped lang="scss">
.budget-dialog {
  border-radius: 8px;
  overflow: hidden;
  .dialog-header {
    padding: 16px;
    background: #fff;

    .dialog-title {
      font-size: 14px;
      font-weight: 600;
      color: #000000;
      text-align: left;
      padding-left: 10px;
    }
  }
  ::v-deep(.van-dialog__content) {
    padding-bottom: 11px;
  }
}
.budget-form {
  padding: 0 16px;
  .van-cell {
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    margin: 0;

    ::v-deep(.van-field__label) {
      width: 80%;
      position: relative;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
    }
    ::v-deep(.van-field__value) {
      margin-top: 8px;
      width: 100%;
      min-height: 27px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #ded9d9;
      padding: 0 9px;
      box-sizing: border-box;
    }
  }
  .van-cell::after {
    border-bottom: none;
  }
  .release,
  .rea {
    ::v-deep(.van-field__value) {
      border: none;
    }
    ::v-deep(.van-radio__icon .van-icon) {
      display: none;
    }
    .van-radio--horizontal {
      width: 50px;
      height: 26px;
      border-radius: 2px;
      border: 1px solid #d6d6d6;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 10px;
      text-align: center;
      ::v-deep(.van-radio__label) {
        margin: 0;
        text-align: center;
        width: 100%;
        line-height: 26px;
      }
    }
    .active {
      border-color: #1989fa;
      ::v-deep(.van-radio__label) {
        color: #2575f2;
      }
    }
  }
  .rea {
    width: 100%;
    height: 36px;
    background: #f8f9fa;
    border-radius: 2px;
    overflow: hidden;
    display: flex;
    align-items: center;

    font-family: PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #000000;

    .van-cell {
      padding: 0;
      margin: 0;
      width: 94px;
      height: 26px;
      border-radius: 2px;
      border: 1px solid #d6d6d6;
      margin: 0 4px 0 8px;
    }
    ::v-deep(.van-field__value) {
      margin: 0;
      padding: 0 5px;
    }
  }
}
#xerox {
  .choosModel {
    margin-top: 12px;
    .models {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;

      #options,
      div {
        margin-top: 15px;
        min-width: 67px;
        height: 32px;
        padding: 0 4px;
        text-align: center;
        display: inline-block;
        line-height: 30px;
        border-radius: 2px;
        background: #f3f3f3;
        color: #000000;
        font-size: 11px;
        margin-right: 10px;
        cursor: pointer;
      }

      .crowd {
        border: 1px solid #d6d6d6;
        background: #fff;
      }

      .activeDiv {
        border: 1px solid #2575f2;
        color: #2575f2;
        background: #fff;
      }

      #options {
        background: #ffffff;
      }
    }

    .invest {
      display: flex;
      margin-top: 10px;
      align-items: center;
      .rept {
        width: 85px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 10px;
        color: #000000;
        line-height: 20px;
        position: relative;
      }
      .stance {
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 10px;
        color: #000000;
        line-height: 20px;
        display: flex;
        align-items: center;
        .enter-input {
          width: 71px;
          height: 26px;
          border-radius: 2px;
          border: 1px solid #ded9d9;
          font-family: Inter;
          font-weight: 400;
          font-size: 10px;
          color: #000000;
          align-items: center;
          margin: 0 5px !important;
          padding: 0 10px !important;
          box-sizing: border-box;
        }
        .rate {
          width: 175px;
          height: 26px;
          border-radius: 2px;
        }
      }
    }
    .van-cell {
      flex-direction: row;
      padding: 0;
      margin-top: 10px;
      ::v-deep(.van-field__label) {
        width: 85px;
        margin-right: 0;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 10px;
        color: #000000;
        line-height: 20px;
      }
      ::v-deep(.van-field__value) {
        margin-top: 0;
        padding: 0;
        border: none;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #1d2129;
        align-items: center;
        .van-radio-group--horizontal {
          flex-direction: column;
          .van-radio {
            margin: 4px;
            .van-radio__icon--round .van-icon {
              border-radius: 3px;
            }
          }
        }
      }
    }
  }
}
</style>
